import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getMyVehicles, getVehicleIdTitles } from "../../../services/vehicleService";
import { IIdTitle } from "../../../models/common/idTitle";
import { MyVehiclesResponseDto, VehicleListItemDto } from "../../../models/vehicle/vehicle";

export interface VehicleState {
    idTitles: IIdTitle[];
    myVehicles: VehicleListItemDto[];
    hasMyVehicles: boolean;
}

const initialState: VehicleState = {
    idTitles: null,
    myVehicles: null,
    hasMyVehicles: false,
};

export const vehicleSlice = createSlice({
    name: "vehicle",
    initialState,
    reducers: {
        setVehicleIdTitles: (state, action: PayloadAction<IIdTitle[]>) => {
            state.idTitles = action.payload;
        },
        setMyVehicles: (state, action: PayloadAction<MyVehiclesResponseDto>) => {
            state.myVehicles = action.payload.vehicles;
            state.hasMyVehicles = action.payload.hasMyVehicles;
        }
    },
});

export const { setVehicleIdTitles, setMyVehicles } = vehicleSlice.actions;

export const fetchVehicles = createAsyncThunk(
    "vehicle/IdTitle",
    async (_, thunkApi) => {
        const idTitles = await getVehicleIdTitles(thunkApi.signal);
        thunkApi.dispatch(setVehicleIdTitles(idTitles));
    }
);

export const fetchMyVehicles = createAsyncThunk(
    "myVehicles",
    async (_, thunkApi) => {
        const myVehicles = await getMyVehicles(thunkApi.signal);
        thunkApi.dispatch(setMyVehicles(myVehicles.data))
    }
)

export const vehicleReducer = vehicleSlice.reducer;
